
namespace TabAurous.HR {

    @Serenity.Decorators.registerClass()
    export class HolidaysGrid extends Serenity.EntityGrid<HolidaysRow, any> {
        protected getColumnsKey() { return 'HR.Holidays'; }
        protected getDialogType() { return HolidaysDialog; }
        protected getIdProperty() { return HolidaysRow.idProperty; }
        protected getInsertPermission() { return HolidaysRow.insertPermission; }
        protected getLocalTextPrefix() { return HolidaysRow.localTextPrefix; }
        protected getService() { return HolidaysService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}